
import { defineComponent, onMounted } from 'vue';
import Sap from '../components/Sap.vue';
import { setPageHeader } from '@/core/helpers/toolbar';

export default defineComponent({
    components: {
        Sap
    },
    setup() {
        onMounted(() => {
            setPageHeader({
                title: 'message.ERP',
                actionButton: null,
                breadCrumbs: [{ name: 'message.HOME', link: '/dashboard' }, { name: 'message.ERP', link: '#' }, { name: 'message.ERP' }]
            });
        });
    }
});
